.ugc-review-mw-all-images-wrap {
  width: 100%;
  overflow: auto hidden;
  .ugc-review-images {
    overflow-x:auto;
    display: grid;
    grid-auto-flow: column;
    grid-template-rows: repeat(2, minmax(0, 1fr));
    gap: 4px;
    .image-item {
      grid-column: span 1 / span 1;
      display: flex;
      > img {
        width: 100%;
        height: 100%;
        width: 80px;
        height: 80px;
        flex-shrink: 0;
      }
      &:nth-of-type(3n + 1) {
        grid-row: 1 / -1;
        grid-row-start: 1;
        grid-column: span 2 / span 2;
        > img {
          width: 164px;
          height: 164px;
          flex-shrink: 0;
        }
      }
    }
  }
}
